/**
 * Haptic Feedback Utilities
 *
 * Provides consistent haptic feedback across the app.
 * Only triggers on native platforms (iOS/Android).
 */

import { Platform } from 'react-native';
import * as Haptics from 'expo-haptics';

/**
 * Light impact - for subtle interactions
 * Use for: toggles, selections, minor state changes
 */
export function hapticLight() {
  if (Platform.OS !== 'web') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
  }
}

/**
 * Medium impact - for standard interactions
 * Use for: button presses, card taps, navigation
 */
export function hapticMedium() {
  if (Platform.OS !== 'web') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
  }
}

/**
 * Heavy impact - for significant interactions
 * Use for: confirmations, important actions, completions
 */
export function hapticHeavy() {
  if (Platform.OS !== 'web') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy);
  }
}

/**
 * Success notification - for positive outcomes
 * Use for: successful saves, completed actions, confirmations
 */
export function hapticSuccess() {
  if (Platform.OS !== 'web') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
  }
}

/**
 * Warning notification - for cautionary feedback
 * Use for: warnings, attention needed, approaching limits
 */
export function hapticWarning() {
  if (Platform.OS !== 'web') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
  }
}

/**
 * Error notification - for negative outcomes
 * Use for: errors, failed actions, validation failures
 */
export function hapticError() {
  if (Platform.OS !== 'web') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error);
  }
}

/**
 * Selection changed - for picker/selection changes
 * Use for: dropdowns, pickers, segmented controls
 */
export function hapticSelection() {
  if (Platform.OS !== 'web') {
    Haptics.selectionAsync();
  }
}
